import Api from '../services/Api';
import { ErrorDictionary } from '../pages/Components/Helpers/ErrorDictionary';
import { ContaPagarRequest, Response } from './Types';

class ContaPagarController {
  public static async Listar(request: ContaPagarRequest): Promise<Response> {
    try {      
      const response = await Api.post(`api/contapagar/Listar`, request);      

      const object = response?.data;

      const retorno: Response = { StatusCode: response.status, Data: object };
      return retorno;
    } catch (error: any) {
      const retorno: Response = {
        StatusCode: error?.response?.status,
        Data: ErrorDictionary(error?.response?.status),
      };
      return retorno;
    }
  }

  public static async ListarUnico(cpp_id: number): Promise<Response> {
    try {
      const response = await Api.get(`api/contapagar/ListarUnico/${cpp_id}`);     
      console.log('PASSOU DA API LISTAR UNICO!!!');
      console.log(response.data); 

      const object = response?.data;

      const retorno: Response = {
        StatusCode: response.status,
        Data: object,
      };
      return retorno;
    } catch (error: any) {
      const retorno: Response = {
        StatusCode: error?.response?.status,
        Data: ErrorDictionary(error?.response?.status),
      };
      return retorno;
    }
  }

  public static async Adicionar(request: any): Promise<any> {
    try {

      const response = await Api.post(`api/contapagar/Adicionar`, request);
            
      const retorno: Response = {StatusCode: response.status};
      return retorno;
    } catch (error: any) {
      return []
    }
  }

  public static async Atualizar(request: ContaPagarRequest): Promise<Response> {
    try {

      const response = await Api.put(`api/contapagar/Atualizar`, request);

      const object = response?.data;

      const retorno: Response = { StatusCode: response.status, Data: object };
      return retorno;
    } catch (error: any) {
      const retorno: Response = {
        StatusCode: error?.response?.status,
        Data: ErrorDictionary(error?.response?.status),
      };
      return retorno;
    }
  }

  public static async QuitarEstornar(request: ContaPagarRequest): Promise<Response> {
    try {

      const response = await Api.put(`api/contapagar/quitar_estornar`, request);

      const object = response?.data;

      const retorno: Response = { StatusCode: response.status, Data: object };
      return retorno;
    } catch (error: any) {
      const retorno: Response = {
        StatusCode: error?.response?.status,
        Data: ErrorDictionary(error?.response?.status),
      };
      return retorno;
    }
  }

  public static async Excluir(request: ContaPagarRequest): Promise<Response> {
    try {

      const response = await Api.post(`api/contapagar/excluir`, request);

      const object = response?.data;

      const retorno: Response = { StatusCode: response.status, Data: object };
      return retorno;
    } catch (error: any) {
      const retorno: Response = {
        StatusCode: error?.response?.status,
        Data: ErrorDictionary(error?.response?.status),
        Message: error.response?.data?.message
      };
      return retorno;
    }
  }
}

export default ContaPagarController;
